import { Select } from 'antd'
import React, { useEffect, useState } from 'react'
import { useGetTyposQuery } from '../../../api/v2/typo'
import { useUsers } from '../useUsers'
import { useMyContext } from '../../../context/context'
import FilterEmpty from './Empty'

const filterById = (id, array) =>
  array.reduce((prev, curr) => {
    if (Array.isArray(curr)) {
      return [...prev, filterById(id, curr)]
    }
    if (curr.id !== id) {
      return [...prev, curr]
    }
    return prev
  }, [])

export default function FilterTypos({ m, setFilters }) {
  const [selectValue, setSelectValue] = useState([])

  const { currentSettings } = useUsers()
  const { myContext } = useMyContext()

  const { data: typos } = useGetTyposQuery(myContext)

  const id = `select-typo-${m.id}`

  useEffect(() => {
    if (currentSettings) {
      const findSelect = currentSettings.usersFilters.flat().find(f => f.id === id)
      setSelectValue(findSelect?.v || [])
    }
  }, [currentSettings, id])

  return (
    <>
      <Select
        value={selectValue}
        allowClear
        popupMatchSelectWidth={false}
        size="small"
        options={typos?.map(t => ({ label: t.label, value: t.id }))}
        mode="multiple"
        onChange={values =>
          setFilters(prev => {
            setSelectValue(values)

            const filters = values.map(value => {
              if (value === 'null') {
                return [
                  {
                    id,
                    operator: '=',
                    value: '',
                    v: 'EMPTY',
                    property: m.id,
                    condition: 'OR',
                  },
                  {
                    id,
                    operator: 'IS',
                    value: 'NULL',
                    v: 'EMPTY',
                    property: m.id,
                    condition: 'OR',
                  },
                ]
              }

              return {
                id,
                operator: 'LIKE',
                value: value === 'null' ? null : value,
                v: value === 'null' ? null : value,
                property: m.id,
                // extended: m.extended ? `$."${m.extended}"."${value}"` : null,
                condition: 'OR',
              }
            })

            return [...filterById(id, prev), filters]
          })
        }
      />
      <FilterEmpty m={m} setFilters={setFilters} />
    </>
  )
}
